import { combineReducers } from 'redux';

import {
	inputValueReducer as inputValue,
	qnaPageReducer as pageData,
	deleteAnswerReducer as deleteAnswer,
	allAnswerReducer as allAnswers,
	moreContentReducer as moreContent,
	searchQnATextReducer as searchQnAData
} from './productQNAReducer';

const questionAndAnswer = combineReducers({
	pageData,
	inputValue,
	deleteAnswer,
	allAnswers,
	moreContent,
	searchQnAData
});

export default questionAndAnswer;
